import { defineComponent as _defineComponent } from 'vue'
import { alertsService } from '@/services/alerts.service';
import { isEmpty } from '@/utils/misc';
import { translateUnit } from '@/utils/number';
import { computed, ref } from 'vue';
import { numeric, required } from '@/utils/validation';
import useVuelidate from '@vuelidate/core';
import { useI18n } from '@/composables/i18n';
import { CareAlert } from '@/models/careAlert';


export default /*#__PURE__*/_defineComponent({
  __name: 'CareAlertEditionModal',
  props: {
    alert: null
  },
  emits: ["save", "close"],
  setup(__props: any, { emit }: { emit: ((e: 'save' | 'close') => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  alert: CareAlert;
};





const threshold = ref(props.alert.threshold);
const isSubmitting = ref(false);

const { t } = useI18n();

const validations = {
  threshold: {
    required,
    numeric,
  },
};
const v$ = useVuelidate(validations, { threshold });

async function submit() {
  const alertToSend = structuredClone(props.alert);
  alertToSend.threshold = threshold.value;

  isSubmitting.value = true;
  try {
    await alertsService.updateCustomAlert(alertToSend);
  } finally {
    isSubmitting.value = false;
  }

  emit('save');
  emit('close');
}

const hasFormChanged = computed(
  () => threshold.value !== props.alert.threshold,
);

const alertKpi = computed(() =>
  alertsService.store.getCareAlertKpiByMetric(props.alert.metric),
);

const kpiUnit = computed(() =>
  translateUnit(alertKpi.value?.unit ?? null, null),
);

const validationMessage = computed(
  () => v$.value.threshold.$errors[0]?.$message,
);

return { __sfc: true,props, emit, threshold, isSubmitting, t, validations, v$, submit, hasFormChanged, alertKpi, kpiUnit, validationMessage, isEmpty }
}

})